@import "../../globalStyles/commons";

@keyframes revealTop {
  0% {
    opacity: 0;
    transform: translateY(-1rem);
    max-height: 0;
  }
  100% {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes revealBottom {
  0% {
    opacity: 0;
    transform: translateY(1rem);
    max-height: 0;
  }
  100% {
    max-height: 500px;
    opacity: 1;
    transform: translateY(0);
  }
}


:host {
  display: block;
  position: absolute;
  z-index: var(--z-index-notification-manager);
  pointer-events: none;
}

:host([name='global']) {
  position: fixed;
  width: 300px;
}

.notification-manager {
  pointer-events: none;
  display: flex;
  flex-direction: column;
  margin: var(--spacing-04);

  .notification {
    pointer-events: auto;
    height: auto;
    max-height: 500px;
    transition: all 0.5s ease-out;
  }

  .notification.hidden {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
}

:host([position="bottom-right"]) {
  bottom: 0;
  right: 0;

  .notification {
    animation: revealBottom 0.5s ease-in;
  }
  .notification-manager {
    align-items: flex-end;
  }
}

:host([position="bottom-left"]) {
  bottom: 0;
  left: 0;

  .notification {
    animation: revealBottom 0.5s ease-in;
  }
  .notification-manager {
    align-items: flex-start;
  }
}

:host([position="top-left"]) {
  top: 0;
  left: 0;

  .notification {
    animation: revealTop 0.5s ease-in;
  }
  .notification-manager {
    align-items: flex-start;
  }
}

:host([position="top-right"]) {
  top: 0;
  right: 0;

  .notification {
    animation: revealTop 0.5s ease-in;
  }
  .notification-manager {
    align-items: flex-end;
  }
}

